// Mount the Reseller package (#216): build its route from what it needs from
// this app — the initialised i18n instance (it registers its `reseller`
// namespace there), the pages of the other modules its tables link to, the
// customer select, and the error page (as the route's errorElement). App.tsx
// mounts the route from HERE, so the package cannot be mounted unregistered.
// configs/i18n is imported (and so initialised) before the registration runs,
// whatever order main.tsx imports things in. The HTTP client goes through
// core's registry (utils/axios/register-core.ts).
import {
    createResellerModule,
    type ResellerHost,
} from '@vnetwork/datacentral-reseller'
import i18n from '@/configs/i18n'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { lazy, Suspense } from 'react'
import { paths } from '@/utils/path'

// Lazy: the select only renders in the add-customer dialog of a reseller's
// detail page. Imported eagerly here it would pull its loaders into the entry
// chunk; before the move it loaded with the Reseller route chunk (#212).
const LazyCustomerSelect = lazy(
    () => import('@/components/Form/Shared/CustomerSelect')
)
const CustomerSelect: ResellerHost['CustomerSelect'] = (props) => (
    <Suspense fallback={null}>
        <LazyCustomerSelect {...props} />
    </Suspense>
)

// The package does not render the app's ErrorPage; the host adds it as the
// route's errorElement, as for Warehouse (#59), Dayoffs (#204) and Business.
export const ResellerRoute = {
    ...createResellerModule({
        i18n,
        // Before the move these were `pathKey`s of the app-wide `paths` inside
        // the tables' route links, invisible to the import graph: they are
        // named here now, so a renamed route fails typecheck in this file.
        links: {
            customerDetail: paths.customerDetail,
            serviceDetail: paths.serviceDetail,
            invoiceDetail: paths.invoiceDetail,
        },
        CustomerSelect,
    }),
    errorElement: <ErrorPage status={500} />,
}
